import React, { useEffect, useState } from "react"
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { FilterWrapper, SearchWrapper } from "../BuyBackFeeStyled";
import MultiSelectDropdownCheckbox from "web/components/MultiSelectDropdownCheckbox";
import { AiOutlineSearch } from "react-icons/ai";
import ExportIcon from "web/assets/svg/ExportIcon";

const Filters = (pageProps) => {
  const { isActive, setFilter, setIsActive, customerMainLocationList, customerSubLocationList, getCustomerSubLocationList, vendorLocationList, tableSearch, handleSearchChange, isDownloadingPtPlusBuyBackFeeCSV, handleExportClick } = pageProps;

  const [customerIds, selectedCustomerIds] = useState([])
  const [locationIds, selectedLocationIds] = useState()
  const [vendorIds, selectedVendorIds] = useState([])

  useEffect(() => {
    setFilter(prevState => ({
      ...prevState,
      active: isActive,
      customerIds,
      locationIds,
      vendorIds
    }));
  }, [isActive, customerIds, locationIds, vendorIds, setFilter])

  useEffect(() => {
    const fetchData = async () => {
      if (customerIds.length > 0) {
        await getCustomerSubLocationList(customerIds);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerIds]);


  return (
    <>
      <FilterWrapper>
        <div className="filter-item-box">
          <FormControlLabel
            style={{ margin: 0 }}
            labelPlacement="start"
            label={"Active"}
            control={
              <Switch
                checked={isActive ? true : false}
                onClick={(e) => {
                  setFilter((prevState) => ({
                    ...prevState,
                    ["active"]: e.target.checked ? true : false,
                  }));
                  setIsActive(e.target.checked ? true : false)
                }
                }
                name="checkedB"
                color="rgba(10, 85, 135, 1)"
              />
            }
          />
        </div>
        <div className="filter-item-box">
          <MultiSelectDropdownCheckbox
            placeholder="Select Customers"
            name="customerIds"
            options={customerMainLocationList}
            selectedStates={customerIds}
            setSelectedStates={selectedCustomerIds}
          // onFilterChange={() => onChangeFilter}
          />
        </div>
        <div className="filter-item-box">
          <MultiSelectDropdownCheckbox
            placeholder="Select Customer Locations"
            name="customerIds"
            options={customerSubLocationList}
            selectedStates={locationIds}
            setSelectedStates={selectedLocationIds}
          // onFilterChange={() => onChangeFilter}
          />
        </div>
        <div className="filter-item-box">
          <MultiSelectDropdownCheckbox
            placeholder="Select Vendors"
            name="vendorIds"
            options={vendorLocationList}
            selectedStates={vendorIds}
            setSelectedStates={selectedVendorIds}
          // onFilterChange={() => onChangeFilter}
          />
        </div>
        <div className="filter-item-box">
          <SearchWrapper>
            <input
              type="text"
              placeholder='Search'
              value={tableSearch}
              onChange={(e) => {
                handleSearchChange(e, e.target.value)
              }}
            />
            <AiOutlineSearch />
          </SearchWrapper>
        </div>
        <div className="filter-item-box">
          <div
            disabled={isDownloadingPtPlusBuyBackFeeCSV}
            onClick={() => {
              handleExportClick()
            }}
            className="export-btn"
          >
            {isDownloadingPtPlusBuyBackFeeCSV ? "Exporting..." : "Export"}
            <ExportIcon />
          </div>
        </div>
      </FilterWrapper>
    </>
  )
}

export default Filters